/**
 * I campi del task che un passaggio di flusso può pretendere, come si chiamano a schermo.
 *
 * Sta in `shared` perché lo legge anche il catalogo degli errori.
 */
export const TASK_REQUESTABLE_FIELDS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'assignee', label: 'Assegnatario' },
  { value: 'queue', label: 'Gruppo' },
  { value: 'project', label: 'Progetto' },
  { value: 'dueDate', label: 'Scadenza' },
  { value: 'start', label: 'Inizio' },
  { value: 'end', label: 'Fine prevista' },
  { value: 'evaluation', label: 'Stima' },
  { value: 'advancement', label: 'Avanzamento' },
  { value: 'description', label: 'Descrizione' },
  { value: 'label', label: 'Etichetta' },
  { value: 'priority', label: 'Priorità' },
];

const LABEL: Record<string, string> = Object.fromEntries(
  TASK_REQUESTABLE_FIELDS.map((f) => [f.value.toLowerCase(), f.label]),
);

/** Il nome a schermo; uno sconosciuto resta com'è. Accetta anche `DueDate`. */
export function taskFieldLabel(field: string): string {
  return LABEL[field.toLowerCase()] ?? field;
}
